"use strict";

var _slicedToArray = require("/home/ubuntu/DF.Viewer.FrontEnd/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCssAndCx = exports.createCssAndCx = void 0;

var classnames_1 = require("./tools/classnames");

var serialize_1 = require("@emotion/serialize");

var utils_1 = require("@emotion/utils");

var useGuaranteedMemo_1 = require("./tools/useGuaranteedMemo");

var cache_1 = require("./cache");

var types_1 = require("./types");

exports.createCssAndCx = function () {
  function merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, utils_1.getRegisteredStyles)(registered, registeredStyles, className);

    if (registeredStyles.length < 2) {
      return className;
    }

    return rawClassName + css(registeredStyles);
  }

  function createCssAndCx(params) {
    var cache = params.cache;

    var css = function css() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var serialized = (0, serialize_1.serializeStyles)(args, cache.registered);
      (0, utils_1.insertStyles)(cache, serialized, false);
      var className = "".concat(cache.key, "-").concat(serialized.name);

      scope: {
        var arg = args[0];

        if (!(0, types_1.matchCSSObject)(arg)) {
          break scope;
        }

        increaseSpecificityToTakePrecedenceOverMediaQuerries.saveClassNameCSSObjectMapping(cache, className, arg);
      }

      return className;
    };

    var cx = function cx() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      var className = (0, classnames_1.classnames)(args);
      var feat27FixedClassnames = increaseSpecificityToTakePrecedenceOverMediaQuerries.fixClassName(cache, className, css);
      return merge(cache.registered, css, feat27FixedClassnames); //return merge(cache.registered, css, className);
    };

    return {
      css: css,
      cx: cx
    };
  }

  return {
    createCssAndCx: createCssAndCx
  };
}().createCssAndCx;
/** Will pickup the contextual cache if any */


function useCssAndCx() {
  var cache = (0, cache_1.useTssEmotionCache)();

  var _ref = (0, useGuaranteedMemo_1.useGuaranteedMemo)(function () {
    return (0, exports.createCssAndCx)({
      cache: cache
    });
  }, [cache]),
      css = _ref.css,
      cx = _ref.cx;

  return {
    css: css,
    cx: cx
  };
}

exports.useCssAndCx = useCssAndCx; // https://github.com/garronej/tss-react/issues/27

var increaseSpecificityToTakePrecedenceOverMediaQuerries = function () {
  var cssObjectMapByCache = new WeakMap();
  return {
    "saveClassNameCSSObjectMapping": function saveClassNameCSSObjectMapping(cache, className, cssObject) {
      var cssObjectMap = cssObjectMapByCache.get(cache);

      if (cssObjectMap === undefined) {
        cssObjectMap = new Map();
        cssObjectMapByCache.set(cache, cssObjectMap);
      }

      cssObjectMap.set(className, cssObject);
    },
    "fixClassName": function () {
      function fix(classNameCSSObjects) {
        var isThereAnyMediaQueriesInPreviousClasses = false;
        return classNameCSSObjects.map(function (_ref2) {
          var _ref3 = _slicedToArray(_ref2, 2),
              className = _ref3[0],
              cssObject = _ref3[1];

          if (cssObject === undefined) {
            return className;
          }

          var out;

          if (!isThereAnyMediaQueriesInPreviousClasses) {
            out = className;

            for (var key in cssObject) {
              if (key.startsWith("@media")) {
                isThereAnyMediaQueriesInPreviousClasses = true;
                break;
              }
            }
          } else {
            out = {
              "&&": cssObject
            };
          }

          return out;
        });
      }

      return function (cache, className, css) {
        var cssObjectMap = cssObjectMapByCache.get(cache);
        return (0, classnames_1.classnames)(fix(className.split(" ").map(function (className) {
          return [className, cssObjectMap === null || cssObjectMap === void 0 ? void 0 : cssObjectMap.get(className)];
        })).map(function (classNameOrCSSObject) {
          return typeof classNameOrCSSObject === "string" ? classNameOrCSSObject : css(classNameOrCSSObject);
        }));
      };
    }()
  };
}();